import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui';

export default function ShareQrCard({ value, title, description }) {
  const { t } = useTranslation();
  const wrapper = useRef(null);
  if (!value) return null;
  const copy = () => navigator.clipboard.writeText(value);
  const share = () => navigator.share ? navigator.share({ title, text: description, url: value }) : copy();
  const download = () => {
    const svg = wrapper.current?.querySelector('svg');
    if (!svg) return;
    const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' }));
    const anchor = document.createElement('a'); anchor.href = url; anchor.download = 'lmcid-qr.svg'; anchor.click(); URL.revokeObjectURL(url);
  };
  return <div className="rounded-3xl border border-primary-100 bg-gradient-to-b from-white to-primary-50/60 p-5 text-center shadow-sm">
    <div ref={wrapper} className="mx-auto inline-flex rounded-3xl bg-white p-4 shadow-lg ring-1 ring-gray-100"><QRCodeSVG value={value} size={190} level="H" marginSize={1} /></div>
    <h3 className="mt-4 font-bold text-gray-900">{title}</h3>{description && <p className="mt-1 text-sm text-gray-500">{description}</p>}
    <p className="mt-3 truncate rounded-xl bg-white px-3 py-2 text-xs text-gray-500">{value}</p>
    <div className="mt-4 flex flex-wrap justify-center gap-2"><Button size="sm" onClick={share}>{t('Share')}</Button><Button size="sm" variant="secondary" onClick={copy}>{t('Copy link')}</Button><Button size="sm" variant="ghost" onClick={download}>{t('Download QR')}</Button></div>
  </div>;
}
